import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

const faqs = [
  {
    q: 'MeBi có hỗ trợ tạo bảng đấu tự động không?',
    a: 'Có. Hệ thống hỗ trợ các dạng bảng đấu phổ biến và tự động bốc thăm, xếp lịch.'
  },
  {
    q: 'Tôi có thể theo dõi kết quả theo thời gian thực?',
    a: 'Có. Người tham gia và khán giả có thể theo dõi kết quả real-time qua ứng dụng hoặc web.'
  },
  {
    q: 'Có bản dùng thử không?',
    a: 'Bạn có thể bắt đầu với gói Starter miễn phí và nâng cấp khi cần.'
  },
]

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center px-4 py-2 bg-mebi-yellow-100 rounded-full mb-6">
              <span className="text-sm font-medium text-mebi-yellow-700">Câu hỏi thường gặp</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-neutral-900">Giải đáp nhanh</h2>
          </div>

          <div className="space-y-4">
            {faqs.map((item, idx) => {
              const isOpen = openIndex === idx
              return (
                <div key={idx} className="rounded-2xl border border-neutral-200 bg-neutral-50">
                  <button
                    className="w-full flex items-center justify-between px-6 py-4"
                    onClick={() => setOpenIndex(isOpen ? null : idx)}
                  >
                    <span className="text-neutral-900 font-semibold">{item.q}</span>
                    <ChevronDown className={`w-5 h-5 text-neutral-700 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                  </button>
                  {isOpen && (
                    <div className="px-6 pb-4 text-neutral-700">
                      {item.a}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}